import styled from '@emotion/styled'
import { color } from 'utils/style'

const TabBackground = styled.div`
  background-color: ${color('surface')};
  margin: 0;
  padding: 0.5em;
`

export default TabBackground
